import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'

import { AppSidebar } from './app-sidebar'
import { ReactNode } from 'react'

interface SidebarLayoutProps {
  children: ReactNode
}

export default function SidebarLayout({ children }: SidebarLayoutProps) {
  return (
    <SidebarProvider>
      <AppSidebar />

      <SidebarInset>
        <div className="flex flex-1 flex-col gap-4 p-4 pt-0 overflow-hidden">
          <div className="overflow-hidden flex-1 rounded-xl">{children}</div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
